import { AuthenticationService } from './../../services/authentication/authentication.service';
import { Component, computed, inject } from '@angular/core';
import {MatMenuModule} from '@angular/material/menu';
import {MatIconModule} from '@angular/material/icon';
import {MatDividerModule} from '@angular/material/divider';
import { ConfigService } from '../../services/config/config.service';

@Component({
  selector: 'app-user-menu',
  imports: [MatMenuModule,MatIconModule,MatDividerModule],
  templateUrl: './user-menu.component.html',
  styleUrl: './user-menu.component.scss'
})
export class UserMenuComponent {
  user = computed(() => this.authenticationService.userSignal());
  configService = inject(ConfigService);
  
  

  constructor(private authenticationService: AuthenticationService) {
  }


  initials = computed(() => {
    const name = this.user()?.name?.trim() || '';
    if (!name) return '';

    const nameParts = name.split(' '); // Split by space
    const firstInitial = nameParts[0]?.charAt(0).toUpperCase() || '';
    const lastInitial = nameParts.length > 1 ? nameParts[nameParts.length - 1].charAt(0).toUpperCase() : '';

    return firstInitial + lastInitial;
  });

  logout() {
    this.authenticationService.logout();
  }

}
